import { render, staticRenderFns } from "./IconAndText.vue?vue&type=template&id=418da5b5&scoped=true"
import script from "./IconAndText.vue?vue&type=script&lang=js"
export * from "./IconAndText.vue?vue&type=script&lang=js"
import style0 from "./IconAndText.vue?vue&type=style&index=0&id=418da5b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418da5b5",
  null
  
)

export default component.exports